import { createApi } from "@reduxjs/toolkit/query/react";
import { authedFetchBaseQuery } from "./authedFetchBaseQuery";

export const financeApiSlice = createApi({
  reducerPath: 'financeApi',
  baseQuery: authedFetchBaseQuery({
    baseUrl: process.env.REACT_APP_FINANCE_API_URL || "http://localhost:8000/api",
  }),
  tagTypes: ['Transactions', 'Categories'],
  endpoints: (builder) => ({
    getTransactions: builder.query({
      query: (userId: string) => `/transactions/${userId}`,
      providesTags: ['Transactions'],
    }),

    addTransaction: builder.mutation({
      query: ({ userId, transaction }: { userId: string; transaction: unknown }) => ({
        url: `/transactions/${userId}`,
        method: 'POST',
        body: transaction,
      }),
      invalidatesTags: ['Transactions'],
    }),

    updateTransaction: builder.mutation({
      query: ({ userId, transactionId, transaction }: { userId: string; transactionId: string; transaction: unknown }) => ({
        url: `/transactions/${userId}/${transactionId}`,
        method: 'PUT',
        body: transaction,
      }),
      invalidatesTags: ['Transactions'],
    }),

    deleteTransaction: builder.mutation({
      query: ({ userId, transactionId }: { userId: string; transactionId: string }) => ({
        url: `/transactions/${userId}/${transactionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Transactions'],
    }),

    getCategories: builder.query({
      query: () => '/categories',
      providesTags: ['Categories'],
    }),

    getFinancialSummary: builder.query({
      query: (userId: string) => `/summary/${userId}`,
      providesTags: ['Transactions'],
    }),
  }),
});

export const {
  useGetTransactionsQuery,
  useAddTransactionMutation,
  useUpdateTransactionMutation,
  useDeleteTransactionMutation,
  useGetCategoriesQuery,
  useGetFinancialSummaryQuery,
} = financeApiSlice;
